// extracted by mini-css-extract-plugin
export default {"content-container":"sliderhf3Elj","content-container--centerAlign":"sliderK6B9R8","content-container--light":"sliderkUHEwm","slide-content":"sliderOeLnBW"};